// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportModalFilter_root__MuwQV","footer":"ReportModalFilter_footer__3uIco"};